module.exports = __webpack_public_path__ + "static/img/image-upload.17de4480.svg";